export const MAX_UPLOAD_SIZE = 5 * 1024 * 1024;

export interface IEmailField {
  name: string;
  phoneNo: string;
  email: string;
  message: string;
  attachment?: File;
}
export interface IEmailProps {
  request: ITicket;
  attachment?: File;
}

interface IRequesterProps {
  name: string;
  email: string;
}

interface IComment {
  body: string;
  uploads?: string[];
}
interface ICustomField {
  id: number | string;
  value: number | string;
}

interface ITicket {
  subject?: string;
  comment: IComment;
  priority: "urgent" | "high" | "normal" | "low";
  requester: IRequesterProps;
  custom_fields: ICustomField[];
}

export type IFileProps = {
  file: File;
  key: string;
  uploadStatus?: "uploading" | "completed" | "error";
  errorMessage?: string;
  uploadProgress?: number;
  onRemove?: () => void;
  onRetry?: () => void;
};
